export const vegetationAreas = [
  {
    id: 1 + '#83b760',
    text: 'wood',
    mapColor: '#83b760',
    lineColor: 'rgb(0, 19, 124)',
    satelliteColor: '#5E0000',
  },
  {
    id: 2 + '#c7e99e',
    text: 'scrub',
    mapColor: '#c7e99e',
    lineColor: 'rgb(80, 106, 252)',
    satelliteColor: '#B00303',
  },
  {
    id: 3 + '#e7f8b0',
    text: 'crop',
    mapColor: '#e7f8b0',
    lineColor: 'rgb(143, 160, 255)',
    satelliteColor: '#E76506',
  },
  {
    id: 4 + '#d7f2a8',
    text: 'grass',
    mapColor: '#d7f2a8',
    lineColor: 'rgb(207, 214, 255)',
    satelliteColor: '#DAC507',
  },
  {
    id: 5 + '#55C100',
    text: 'other',
    mapColor: 'rgb(255, 255, 255)',
    lineColor: 'rgb(255, 147, 147)',
    satelliteColor: '#55C100',
  },
];